import React from 'react';
import CountUp from 'react-countup';
import StatsSection from './Home-stats';

const HomeAbout = () => {
  return (
    <section className="px-4 py-8 lg:px-8">
      <div className="sm:flex items-center mx-auto max-w-7xl">
      {/* Text Section - Left Side */}
      <div className="sm:w-1/2 lg:p-5">
        <div className="text">
          <span className="text-gray-500 border-b-2 border-[#E12126] uppercase">
          Your Digital Partner in Success and Innovation
          </span>
          <h2 className="my-4 font-bold text-3xl sm:text-4xl">
          Precision Driven Strategies for <span className="text-[#21AA4A]"> Sustainable Growth</span>
          </h2>
          <p className="text-gray-700 text-[12px] lg:text-[16px] mb-8">
We provide customized digital solutions that drive measurable results and support sustainable business growth. From bespoke website and mobile app development to data driven digital marketing, we leverage advanced technologies to enhance your brand’s online presence. With a focus on user experience and performance, we position your business for success in the digital landscape.          </p>
        </div>
      </div>
      
      {/* Image Section - Right Side */}
      <div className="sm:w-1/2 p-0 lg:pb-10 md:p-5">
    <StatsSection/>
      </div>
    </div>
    </section>
  );
};

export default HomeAbout;
